(() => {
  const initialized = new WeakSet();
  const retryButtons = new WeakMap();
  const pending = new WeakSet();
  function play(video) {
    if (pending.has(video)) return;
    pending.add(video);
    Promise.resolve(video.play()).catch(error => {
      if (error.name === 'NotAllowedError' && eligible(video)) {
        const button = retryButtons.get(video);
        if (button) button.hidden = false;
      }
    }).finally(() => pending.delete(video));
  }
  function load(video) {
    if (video.dataset.lpLoaded) return;
    video.dataset.lpLoaded = 'true';
    video.querySelectorAll('source[data-src]').forEach(source => {
      source.src = source.dataset.src;
    });
    video.load();
  }
  const visible = new Set();
  const mobile = window.matchMedia('(max-width: 767px)');
  function eligible(video) {
    const item = video.closest('[data-lp-prep-item]');
    const front = !item || !mobile.matches || (item.closest('.is-prep-ready')
      ? item.classList.contains('is-front') : item.dataset.lpPrepIndex === '0');
    return visible.has(video) && !document.hidden && front;
  }
  function syncPlayback(video) {
    if (eligible(video)) {
      load(video);
      play(video);
    } else {
      video.pause();
      const button = retryButtons.get(video);
      if (button) button.hidden = true;
    }
  }
  document.addEventListener('lp:prep-change', () => visible.forEach(syncPlayback));
  mobile.addEventListener('change', () => visible.forEach(syncPlayback));
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(({ target: video, isIntersecting }) => {
      if (isIntersecting) {
        visible.add(video);
        syncPlayback(video);
      } else {
        visible.delete(video);
        syncPlayback(video);
      }
    });
  }, { threshold: 0.01 }) : null;
  function init(root = document) {
    root.querySelectorAll('[data-lp-lazy-video]').forEach(video => {
      if (initialized.has(video)) return;
      initialized.add(video);
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.setAttribute('webkit-playsinline', '');
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'lp-video-retry';
      button.textContent = video.dataset.lpPlayLabel || 'Play video';
      button.hidden = true;
      button.addEventListener('click', () => syncPlayback(video));
      video.parentElement.append(button);
      retryButtons.set(video, button);
      video.addEventListener('playing', () => {
        button.hidden = true;
        if (observer && !eligible(video)) video.pause();
      });
      if (observer) observer.observe(video);
      else { video.controls = true; video.addEventListener('pointerdown', () => load(video), { once: true }); }
    });
    root.querySelectorAll('[data-lp-load-video]').forEach(button => {
      if (initialized.has(button)) return;
      initialized.add(button);
      button.addEventListener('click', () => {
        const video = button.parentElement.querySelector('[data-lp-click-video]');
        load(video);
        button.hidden = true;
        button.style.display = 'none';
        Promise.resolve(video.play()).catch(() => {
          button.hidden = false;
          button.style.display = 'grid';
        });
        video.focus();
      });
    });
  }
  const retryVisible = () => visible.forEach(video => {
    if (video.paused) syncPlayback(video);
  });
  ['touchend', 'click', 'keydown', 'WeixinJSBridgeReady'].forEach(type => {
    document.addEventListener(type, retryVisible, { passive: true });
  });
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-lp-lazy-video]').forEach(video => {
      observer?.unobserve(video);
      visible.delete(video);
      video.pause();
    });
  });
  document.addEventListener('visibilitychange', () => {
    visible.forEach(video => {
      syncPlayback(video);
    });
  });
})();
